export default "__VITE_ASSET__27d3272e__"